import { render } from "./SocialNetwork.vue?vue&type=template&id=ff058bd6&ts=true&lang=pug"
import script from "./SocialNetwork.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialNetwork.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__